import { BaseFieldProps } from "./BaseFieldProps";
import React from "react";
import { OIDCUrlField } from "./OIDCUrlField";

export const TokenURLField = ({ disabled, onChange, value = "" }: BaseFieldProps) => {
    return (
        <OIDCUrlField
            id="token"
            label="Token URL"
            placeholder="Token URL"
            description="URL of the OAuth 2.0 Token Endpoint"
            examples={["(i.e. https://idp.example.com/oauth2/token)"]}
            disabled={disabled}
            onChange={onChange}
            value={value}
        />
    );
};

TokenURLField.displayName = "TokenURLField";
